import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu"];

  connect() {
    const links = this.element.querySelectorAll("a, button");
    links.forEach((link) => {
      if (link.dataset.turboFrame) {
        link.dataset.action = "click->dropdown#hideMenu";
      }
    });
  }

  toggleMenu() {
    const isActive = this.menuTarget.dataset.hidden === "false";
    if (isActive) {
      this.hideMenu();
    } else {
      this.menuTarget.dataset.hidden = false;
    }
  }

  hideMenu() {
    this.menuTarget.dataset.hidden = true;
  }

  closeOnClick(event) {
    if (event && this.element.contains(event.target)) {
      return;
    }
    this.hideMenu();
  }
}
